import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { MobileBar } from "@/components/site/MobileBar";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Book from "@/pages/Book";
import Contact from "@/pages/Contact";
import Areas from "@/pages/Areas";
import AreaDetail from "@/pages/AreaDetail";
import TwentyFourSeven from "@/pages/TwentyFourSeven";
import Projects from "@/pages/Projects";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";

const SiteLayout = () => (
  <>
    <Header />
    <main><Outlet /></main>
    <Footer />
    <MobileBar />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <SmoothScroll />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/book" element={<Book />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/areas" element={<Areas />} />
              <Route path="/areas/:slug" element={<AreaDetail />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/24-hour-service" element={<TwentyFourSeven />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
